// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductsUI_view__g60rx {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ProductsUI_loader__wXdmu {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.ProductsUI_description__j7ebK {
  width: 200px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ProductsUI_input__NhRKl {
  background-color: #fbfbfb;
  border-color: #d2d2d2;
  border-radius: 4px;
  width: 300px;
}

.ProductsUI_buttons__3Bx60 {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.ProductsUI_actions__i6XBL {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
}

@media (max-width: 768px) {
  .ProductsUI_buttons__3Bx60 {
    flex-direction: column;
    align-items: stretch;
  }

  .ProductsUI_mainButton__ZhkMA {
    width: 100% !important;
  }
}

.ProductsUI_menu__4MYUE {
  cursor: pointer;
}

.ProductsUI_mainButton__ZhkMA {
  width: 200px;
  font-weight: 500;
}

.ProductsUI_header__3sbnh {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.ProductsUI_title__n2PYS {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 20px;
}

.ProductsUI_label__lp4gA {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 12px;
}

.ProductsUI_input__NhRKl,
.ProductsUI_input__NhRKl .ant-select-selector {
  background-color: #fbfbfb !important;
  border-color: #d2d2d2 !important;
  border-radius: 4px !important;
}

.ProductsUI_itemColumn__GSaLo {
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.ProductsUI_itemSubmit__3Mmba {
  margin-bottom: 0px;
  text-align: right;
  margin-top: 20px;
}

.ProductsUI_submit__Js-e3 {
  width: 250px;
  font-weight: 700;
  font-size: 13px;
}

.ProductsUI_availableChannels__e\\+haU {
  .ProductsUI_availableChannels_description__yMTug {
    margin-bottom: 20px;
  }
  .ProductsUI_channels__OWy4Z {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    >.ProductsUI_channel__XZILX {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.5rem 0.75rem;
      background-color: #f9f9f9;
      border-radius: 0.375rem;
      &.ProductsUI_disabled__c\\+V-j {
        background-color: #f0f0f0;
        cursor: not-allowed;
        >span {
          color: #c9c9c9;
        }
      }
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/productsbySucursal/styles/ProductsUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAGA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IAEZ;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,uBAAuB;MACvB,yBAAyB;MACzB,uBAAuB;MAEvB;QACE,yBAAyB;QACzB,mBAAmB;QAEnB;UACE,cAAc;QAChB;MACF;IACF;EACF;AACF","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.description {\n  width: 200px;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.input {\n  background-color: #fbfbfb;\n  border-color: #d2d2d2;\n  border-radius: 4px;\n  width: 300px;\n}\n\n.buttons {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.actions {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n@media (max-width: 768px) {\n  .buttons {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .mainButton {\n    width: 100% !important;\n  }\n}\n\n.menu {\n  cursor: pointer;\n}\n\n.mainButton {\n  width: 200px;\n  font-weight: 500;\n}\n\n\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.title {\n  color: var(--darkGray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.label {\n  font-weight: 500;\n  color: var(--darkGray);\n  font-size: 12px;\n}\n\n.input,\n.input :global(.ant-select-selector) {\n  background-color: #fbfbfb !important;\n  border-color: #d2d2d2 !important;\n  border-radius: 4px !important;\n}\n\n\n.itemColumn {\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.itemSubmit {\n  margin-bottom: 0px;\n  text-align: right;\n  margin-top: 20px;\n}\n\n.submit {\n  width: 250px;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.availableChannels {\n  .availableChannels_description {\n    margin-bottom: 20px;\n  }\n\n  .channels {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n\n    >.channel {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0.5rem 0.75rem;\n      background-color: #f9f9f9;\n      border-radius: 0.375rem;\n\n      &.disabled {\n        background-color: #f0f0f0;\n        cursor: not-allowed;\n\n        >span {\n          color: #c9c9c9;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `ProductsUI_view__g60rx`,
	"loader": `ProductsUI_loader__wXdmu`,
	"description": `ProductsUI_description__j7ebK`,
	"input": `ProductsUI_input__NhRKl`,
	"buttons": `ProductsUI_buttons__3Bx60`,
	"actions": `ProductsUI_actions__i6XBL`,
	"mainButton": `ProductsUI_mainButton__ZhkMA`,
	"menu": `ProductsUI_menu__4MYUE`,
	"header": `ProductsUI_header__3sbnh`,
	"title": `ProductsUI_title__n2PYS`,
	"label": `ProductsUI_label__lp4gA`,
	"itemColumn": `ProductsUI_itemColumn__GSaLo`,
	"itemSubmit": `ProductsUI_itemSubmit__3Mmba`,
	"submit": `ProductsUI_submit__Js-e3`,
	"availableChannels": `ProductsUI_availableChannels__e+haU`,
	"availableChannels_description": `ProductsUI_availableChannels_description__yMTug`,
	"channels": `ProductsUI_channels__OWy4Z`,
	"channel": `ProductsUI_channel__XZILX`,
	"disabled": `ProductsUI_disabled__c+V-j`
};
export default ___CSS_LOADER_EXPORT___;
